<template>
    <v-overlay>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
</template>

<script>
    import {computed, onMounted} from '@vue/composition-api';
    import {DateTime} from "luxon";
    import XLSX from 'xlsx';
    import eConfig from "../../evention-config.js";
    import axios from 'axios';

    export default {
        name: 'EventReportAppAction',
        setup(props, {root}) {
            const {Event} = root.$FeathersVuex.api;

            const eventId = computed(() => root.$route.params.eventId);
            const dbColMapping = eConfig.reportAppAction.dbColMapping;

            const isTemplate = computed(() => root.$route.params.isTemplate);
            const timeslots = computed(() => root.$route.params.timeslots);
            
            const exportReport = async () => {
                const event = await Event.get(eventId.value);

                let excelData = [];
                if (!isTemplate.value) {
                    let stats;
                    try {
                        const prefixUrl = process.env.VUE_APP_SERVER_ADDRESS;
                        stats = await axios.create({
                            headers: {'Authorization': window.localStorage.getItem('feathers-jwt')}
                        }).post(`${prefixUrl}/report-api/app-action`, {
                            eventId: eventId.value,
                            // Default date range is from 1970-01-01 to now
                            timeslots: timeslots.value.length !== 0 ? timeslots.value : [[(new Date(0)).toISOString(), (new Date()).toISOString()]]
                        });
                    } catch (e) {
                        root.$handleFeatherError(e);
                    }
    
                    const unknownMapping = {}; // for new dbColMapping not configured in evention-config.js
                    for (const item of stats.data) {
                        const row = [];
                        row.push(DateTime.fromISO(item.start_time).setZone('Asia/Hong_Kong').toFormat('dd/LL/yyyy HH:mm:ss'));
                        row.push(DateTime.fromISO(item.end_time).setZone('Asia/Hong_Kong').toFormat('dd/LL/yyyy HH:mm:ss'));
                        delete item.start_time;
                        delete item.end_time;
                        for (const value of Object.values(dbColMapping)) {
                            if (item.hasOwnProperty(value)) {
                                row.push(item[value]);
                                delete item[value];
                            } else {
                                row.push(0);
                            }
                        }
                        for (const key of Object.keys(unknownMapping)) {
                            row.push(item[key]);
                            delete item[key];
                        }
                        for (const key of Object.keys(item)) {
                            unknownMapping[key] = key;
                            row.push(item[key]);
                        }
                        excelData.push(row);
                    }
                    excelData.unshift(['Start Time', 'End Time', ...Object.keys(dbColMapping), ...Object.keys(unknownMapping)]);
                } else {
                    excelData.unshift(['Start Time', 'End Time']);
                }
                
                const ws = XLSX.utils.aoa_to_sheet(excelData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, event.name);
                XLSX.writeFile(wb, 'app_action_report_'+eventId.value+'_'+DateTime.local().toFormat('yyyyMMdd_HHmmss')+'.xlsx');
                
                root.$router.go(-1);
            }
            
            onMounted(() => {
                exportReport();
            });

            return {
            }
        },
    }
</script>
